const style = {
  capsule: {
    width: '100%',
    position: 'relative',
  },
  upsideCapsule: {
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  header: {
    borderRadius: '5px 5px 0 0',
    backgroundColor: '#0480a9',
    height: '4px',
    position: 'static',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1,
  },
  upsideHeader: {
    borderRadius: '0 0 5px 5px',
  },
  headerLarge: {
    backgroundColor: '#005589',
    height: '48px',
    position: 'relative',
  },
  headerAuto: {
    backgroundColor: '#005589',
    position: 'relative',
    padding: '10px',
    height: 'auto',
  },
  content: {
    position: 'relative',
    borderRadius: '0 0 5px 5px',
    backgroundColor: '#fff',
    overflow: 'hidden',
    boxShadow: '0 10px 20px 0 rgba(0,0,0,0.05)',
    border: 'solid 1px #d4d1d1',
  },
  upsideContent: {
    marginTop: '-1px',
    borderRadius: '5px 5px 0 0',
  },
  contentNoHeader: {
    marginTop: '-1px',
    borderRadius: '5px',
  },
  contentLargeHeader: {
    paddingTop: '34px',
    marginTop: '-35px',
  },
  upsideContentLargeHeader: {
    paddingTop: '0',
    marginTop: '0',
    paddingBottom: '34px',
    marginBottom: '-35px',
  },
  label: {
    fontFamily:
      'Trident, HappinessBeta, HappinessBeta-New, HappinessBeta wf, Verdana, Arial, sans-serif',
    verticalAlign: '-3px',
  },
  checkIcon: {
    position: 'absolute',
    display: 'flex',
    top: '-12px',
    right: '-9px',
    left: '-9px',
    justifyContent: 'flex-end',
  },
};

export const styles = ({
  additionalStyle = {
    header: {},
    content: {},
    icon: {},
    label: {},
  },
  color,
  isHeaderNone,
  isLargeHeader,
  isHeaderAuto,
  upside,
}) => ({
  computedCapsuleStyle: {
    ...style.capsule,
    ...(upside ? style.upsideCapsule : null),
    ...additionalStyle.root,
  },
  computedHeaderStyle: {
    ...style.header,
    ...(isLargeHeader ? style.headerLarge : null),
    ...(isHeaderAuto ? style.headerAuto : null),
    ...(upside ? style.upsideHeader : null),
    ...(color ? { backgroundColor: color } : null),
    ...additionalStyle.header,
  },

  computedContentStyle: {
    ...style.content,
    ...(upside ? style.upsideContent : null),
    ...(isLargeHeader ? style.contentLargeHeader : null),
    ...(isLargeHeader && upside ? style.upsideContentLargeHeader : null),
    ...(isHeaderNone ? style.contentNoHeader : null),
    ...additionalStyle.content,
  },

  computedIconWrapperStyle: {
    ...additionalStyle.icon,
  },

  computedLabelStyle: {
    ...style.label,
    ...additionalStyle.label,
  },

  computedCheckIconStyle: {
    ...style.checkIcon,
  },
});
